import React from 'react'
import './custom_button.css'

class CustomButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let sub = (
            <div></div>
        )
        if (this.props.description) {
            sub = (
                <p>
                    {this.props.description}
                </p>
            )
        }
        return (
            <button className={"customButton gsap-slide" + (this.props.description && this.props.description!="" ? " hasSub" : "") } onClick={this.props.handler}>
                {this.props.value}
                {sub}
            </button>
        )
    }
}

export default CustomButton


// WEBPACK FOOTER //
// ./src/components/shared/custom_button.js